

/**
 * CentroLoaderWrapper to wrap around the centro-hvc-loader function such as bootstrapFeature, createStaticDataSource, initialize, preloadFeature
 * Therefore, we can mock those function by Jasmine for testing
 */
import { bootstrapFeature, createStaticDataSource, initialize, preloadFeature } from "@ms/centro-hvc-loader"


export class CentroLoaderWrapper {
	static readonly bootstrapFeature = bootstrapFeature;
	static readonly createStaticDataSource = createStaticDataSource;
	static readonly initialize = initialize;
	static readonly preloadFeature = preloadFeature;
}
